<div class="container">
  <div class="slider-wrap__engine">
    <div class="placeholder placeholder__engine rounded-1 w-100"></div>
  </div>
</div>
